export const styles: any = {
  flexDirection: { lg: 'row' },
  imageContainerW: { lg: '50%' },
  imageW: { base: '128px', lg: '304px' },
  imageH: { base: '128px', lg: '304px' },
  boxMt: { base: 0, lg: 0 },
  titleFontSize: { base: 'xl', lg: '3xl' },
  titleAlignment: { base: 'center', lg: 'left' },
  subTitleAlignment: { base: 'center', lg: 'left' },
  buttonContainerDisplay: { base: 'none', lg: 'flex' },
};
